module.exports = __webpack_public_path__ + "static/media/lila.1c316997.png";